import { render } from "./PostModal.vue?vue&type=template&id=c1976408"
import script from "./PostModal.vue?vue&type=script&lang=ts"
export * from "./PostModal.vue?vue&type=script&lang=ts"
script.render = render

export default script